"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findNextActivity = exports.findNextTransport = exports.findNextHireCar = exports.findNextHotel = exports.findNextFlight = exports.generateUpNextForUser = void 0;
const date_1 = require("../date/date");
/**
 * Compare two dates to see if same?
 * returns false for if they are the same
 * returns true for if they are not the same
 */
const notSameDate = (date1, date2) => {
    if (!date1 || !date2)
        return false;
    return (date1.dateTimeString.slice(0, 10) !== date2.dateTimeString.slice(0, 10));
};
const getDateRanges = (start, end) => {
    const dates = [];
    const startDate = start.getCloneEventrDate();
    const endDate = end.getCloneEventrDate();
    for (const d = start.getCloneEventrDate(); d.toItinLocalDateString() < endDate.toItinLocalDateString(); d.add({ days: 1 })) {
        if (d.toItinLocalDateString() !== startDate.toItinLocalDateString()) {
            const date = d.getCloneEventrDate();
            d.setFromObject({ hour: 0, minute: 0 });
            dates.push(date);
        }
    }
    return dates;
};
const generateUpNextForUser = (user, itineraryData) => {
    const nextFlight = (0, exports.findNextFlight)(user, itineraryData[2]);
    const nextHotel = (0, exports.findNextHotel)(user, itineraryData[3]);
    const nextHireCar = (0, exports.findNextHireCar)(user, itineraryData[4]);
    const nextTransport = (0, exports.findNextTransport)(user, itineraryData[5]);
    const nextActivity = (0, exports.findNextActivity)(user, itineraryData[8]);
    return {
        flight: nextFlight?.bookref || null,
        hotel: nextHotel?.name || null,
        hireCar: nextHireCar?.car_alias || null,
        transport: nextTransport?.transport_alias || null,
        activity: nextActivity?.activity_name || null,
    };
};
exports.generateUpNextForUser = generateUpNextForUser;
// find the next flight for a user
const findNextFlight = (user, flights) => {
    if (!flights || !flights.flights || flights.flights.length === 0)
        return null;
    const userId = user.id.toString();
    const now = Date.now();
    const userFlights = flights.flights.filter((flight) => flight.passengers_list?.some((passengerList) => passengerList.users?.some((u) => u.option?.toString() === userId)));
    if (userFlights.length === 0)
        return null;
    // Find the next upcoming flight based on departure time
    const upcomingFlights = userFlights.filter((flight) => {
        const departureTimeUtc = new date_1.EventrDate(flight.departure.dep_time)
            .getUnixMs;
        return departureTimeUtc > now;
    });
    if (upcomingFlights.length === 0)
        return null;
    // Sort by departure time and get the soonest flight
    return upcomingFlights.sort((a, b) => new date_1.EventrDate(a.departure.dep_time).getUnixMs -
        new date_1.EventrDate(b.departure.dep_time).getUnixMs)[0];
};
exports.findNextFlight = findNextFlight;
const findNextHotel = (user, hotels) => {
    if (!hotels || !hotels.hotels || hotels.hotels.length === 0)
        return null;
    const userId = user.id.toString();
    const now = Date.now();
    // Find hotels with rooms where the user is listed as a guest
    const userHotels = hotels.hotels.filter((hotel) => hotel.rooms?.some((room) => room.guests?.some((guest) => guest.option?.toString() === userId)));
    if (userHotels.length === 0)
        return null;
    // For each hotel, find rooms where the user is a guest and check-in is in the future
    const nextHotelRooms = [];
    userHotels.forEach((hotel) => {
        if (hotel.rooms) {
            const userRooms = hotel.rooms.filter((room) => {
                // Check if user is a guest in this room
                const isGuest = room.guests?.some((guest) => guest.option?.toString() === userId);
                let checkInTimeUnix = 0;
                if (room.override) {
                    checkInTimeUnix = new date_1.EventrDate(room.checkIn).getUnixMs;
                }
                else {
                    checkInTimeUnix = new date_1.EventrDate(hotel.defualtCheckIn)
                        .getUnixMs;
                }
                // Check if check-in time is in the future
                return isGuest && checkInTimeUnix > now;
            });
            userRooms.forEach((room) => {
                nextHotelRooms.push({ hotel, room });
            });
        }
    });
    if (nextHotelRooms.length === 0)
        return null;
    // Sort by check-in time and get the soonest hotel room
    const nextHotelRoom = nextHotelRooms.sort((a, b) => new date_1.EventrDate(a.room.checkIn).getUnixMs -
        new date_1.EventrDate(b.room.checkIn).getUnixMs)[0];
    return nextHotelRoom.hotel;
};
exports.findNextHotel = findNextHotel;
const findNextHireCar = (user, hireCars) => {
    if (!hireCars || !hireCars.hireCars || hireCars.hireCars.length === 0)
        return null;
    const userId = user.id.toString();
    const now = Date.now();
    // Find hire cars where the user is either a passenger or driver
    const userHireCars = hireCars.hireCars.filter((hireCar) => hireCar.passengers_list?.some((passenger) => passenger.users?.some((u) => u.option?.toString() === userId)));
    if (userHireCars.length === 0)
        return null;
    // Find the next upcoming hire car based on pick-up time
    const upcomingHireCars = userHireCars.filter((hireCar) => {
        if (!hireCar.pick_up)
            return false;
        const pickUpTimeUnix = new date_1.EventrDate(hireCar.pick_up).getUnixMs;
        return pickUpTimeUnix > now;
    });
    if (upcomingHireCars.length === 0)
        return null;
    // Sort by pick-up time and get the soonest hire car
    return upcomingHireCars.sort((a, b) => new date_1.EventrDate(a.pick_up).getUnixMs -
        new date_1.EventrDate(b.pick_up).getUnixMs)[0];
};
exports.findNextHireCar = findNextHireCar;
const findNextTransport = (user, transports) => {
    if (!transports ||
        !transports.transport ||
        transports.transport.length === 0)
        return null;
    const userId = user.id.toString();
    const now = Date.now();
    // Find transports where the user is either a passenger or driver
    const userTransports = transports.transport.filter((transport) => {
        // Check if user is in passengers list
        const isPassenger = transport.passengers_list?.some((passengerList) => passengerList.users?.some((u) => u.option?.toString() === userId));
        // Check if user is in drivers list
        const isDriver = transport.passengers_list?.some((passengerList) => passengerList.drivers?.some((d) => d.option?.toString() === userId));
        return isPassenger || isDriver;
    });
    if (userTransports.length === 0)
        return null;
    // Find the next upcoming transport based on pick-up time
    const upcomingTransports = userTransports.filter((transport) => {
        if (!transport.pick_up)
            return false;
        const pickUpTimeUnix = new date_1.EventrDate(transport.pick_up).getUnixMs;
        return pickUpTimeUnix > now;
    });
    if (upcomingTransports.length === 0)
        return null;
    // Sort by pick-up time and get the soonest transport
    return upcomingTransports.sort((a, b) => new date_1.EventrDate(a.pick_up).getUnixMs -
        new date_1.EventrDate(b.pick_up).getUnixMs)[0];
};
exports.findNextTransport = findNextTransport;
const findNextActivity = (user, activities) => {
    if (!activities ||
        !activities.activities ||
        activities.activities.length === 0)
        return null;
    const userId = user.id.toString();
    const now = Date.now();
    // Filter activities that have the user in attendees list
    const userActivities = activities.activities.filter((activity) => activity.attendees_list?.some((attendeeList) => attendeeList.users?.some((u) => u.option?.toString() === userId)));
    if (userActivities.length === 0)
        return null;
    // Find the next upcoming activity based on start time
    const upcomingActivities = userActivities.filter((activity) => {
        if (!activity.start)
            return false;
        const startTimeUnix = new date_1.EventrDate(activity.start).getUnixMs;
        return startTimeUnix > now;
    });
    if (upcomingActivities.length === 0)
        return null;
    // Sort by start time and get the soonest activity
    return upcomingActivities.sort((a, b) => {
        const aStart = a.start
            ? new date_1.EventrDate(a.start).getUnixMs
            : Number.MAX_SAFE_INTEGER;
        const bStart = b.start
            ? new date_1.EventrDate(b.start).getUnixMs
            : Number.MAX_SAFE_INTEGER;
        return aStart - bStart;
    })[0];
};
exports.findNextActivity = findNextActivity;
